export default "__VITE_ASSET__CxWvZOly__"